// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x646","col":"styles_col__3ztVF"};